/**
 * ============================================================
 * LNV Premium Motion System
 * Version: 2.0
 * ============================================================
 */

(function () {
  'use strict';

  function initReveal(root = document, selector = '.lnv-reveal') {
    const elements = root.querySelectorAll(selector);

    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15
      }
    );

    elements.forEach((element) => observer.observe(element));
  }

  window.LNVMotion = {
    initReveal
  };

  document.addEventListener('DOMContentLoaded', () => {
    initReveal(document, '.lnv-reveal');

    document.dispatchEvent(
      new CustomEvent('lnv:motion:ready')
    );
  });

})();